import Box, { BoxProps } from 'app/components/base/Box'

import ProductsDesktopFilter from './ProductsDesktopFilter'
import ProductsMobileFilter from './ProductsMobileFilter'

type ProductsFilterProps = {
  sx?: BoxProps['sx']
  partNumbers: string[]
}

const ProductsFilter: RFC<ProductsFilterProps> = ({ sx, partNumbers }) => {
  return (
    <Box sx={sx}>
      <ProductsDesktopFilter partNumbers={partNumbers} />
      <ProductsMobileFilter partNumbers={partNumbers} />
    </Box>
  )
}

export default ProductsFilter
